export const animationSettings = {
  mainSpine: {
    'default': ['interactive', false, 'static'],
    'INIT:REGULAR': ['play', true, 'main-bg'],
    'INIT:FREESPINS': ['play', true, 'fs-bg'],
    'BG-PLAY': ['play', true, 'main-bg'],
    'BG-IN': ['play', false, 'main-to-fs-pop', { name: 'BG-PLAY', delay: 1.5 }],
    'STATE:IN:FS-START': ['play', false, 'main-to-fs-pop', { name: 'BG-FS-ADD-LOOP', delay: 15 }],
    'BG-FS-ADD-LOOP': ['play', true, 'fs-start-pop-loop'],
    'BUTTON:startFreespin': ['play', false, 'fs-popup-to-fs-bg', { name: 'FS-ADD-FS-BG', delay: 1 }],
    'FS-ADD-FS-BG': ['play', true, 'fs-bg'],
    'STATE:IN:FS-END': ['play', false, 'fs-bg-to-fs-pop', { name: 'FS-BG-FS-END', delay: 1.5 }],
    'FS-BG-FS-END': ['play', true, 'fs-end-pop-loop'],
    'BUTTON:endFreespin': ['play', false, 'end-pop-to-main-bg', { name: 'BG-PLAY', delay: 3 }],
  },
}
